import { gql } from 'apollo-angular';

/**
 * Queries related to session management.
 */
export class sessionQueries {
	public static getUserDetails = gql`
		query getUserDetails($sessionId: String!) {
			getUserDetails(sessionId: $sessionId) {
				SessionUID
				Username
				Company
				Email
				IsAuthenticated
				IdToken
			}
		}
	`;

	public static validateSessionId = gql`
		query validateSessionId($sessionId: String!) {
			validateSessionId(sessionId: $sessionId)
		}
	`;

	public static ping = gql`
		query ping {
			ping
		}
	`;
}
